import { GeoFeature } from './GeoFeature';
import { TreeType } from '../../enumerations/TreeType';
import { Bounds } from '../../../../utils/map/MapUtils';
import OrgUnitProperties from '@legacy-modules/metrics2/models/entities/organization/OrgUnitProperties';
import { OrgUnitResult } from '@legacy-modules/metrics2/models/entities/organization/OrgUnitResult';

export type OrgUnitPart = 'geometry' | 'properties' | 'children' | 'breadcrumb' | 'treeTypes';

export default class OrgUnit {
  // default part
  orgKey: string;
  name: string;
  orgType: string;
  treeType: TreeType | null | undefined;
  bbox: [number, number, number, number];
  // part: properties
  properties: OrgUnitProperties | null | undefined;
  // part: geometry
  type?: string;
  geometry?: GeoFeature;
  // part: children
  children?: Array<string>;
  // part: treeTypes
  treeTypes?: Array<TreeType>;
  // part: breadcrumb
  breadcrumb?: Array<string>;
  parent: OrgUnit;
  validTill: string;

  constructor(orgUnitResult: OrgUnitResult | null | undefined = null) {
    if (orgUnitResult) {
      this.orgKey = orgUnitResult.orgKey;
      this.name = orgUnitResult.name;
      this.orgType = orgUnitResult.orgType;
      this.treeType = orgUnitResult.treeType;
      this.bbox = orgUnitResult.bbox;
      // part: properties
      this.properties = orgUnitResult.properties && new OrgUnitProperties(orgUnitResult.properties);
      // part: geometry
      this.type = orgUnitResult.type;
      this.geometry = orgUnitResult.geometry;
      // part: children
      this.children = orgUnitResult.children;
      // part: treeTypes
      // @ts-ignore
      this.treeTypes = orgUnitResult.treeTypes;
      // part: breadcrumb
      this.breadcrumb = orgUnitResult.breadcrumb;
    }
  }

  get parentOrgKey(): string | null | undefined {
    if (!this.breadcrumb || this.breadcrumb.length <= 1) {
      return null;
    }
    return this.breadcrumb[this.breadcrumb.length - 2];
  }

  get mapboxBoundingBox(): Bounds {
    return [
      [this.bbox[0], this.bbox[1]],
      [this.bbox[2], this.bbox[3]],
    ];
  }

  static getPath(node: OrgUnit): OrgUnit[] {
    if (!node.parent) {
      return [node];
    }
    return [node, ...OrgUnit.getPath(node.parent)];
  }
}
